var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-plus-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9318 9.00008H11.0985V3.16675C11.0985 2.90153 10.9931 2.64718 10.8056 2.45964C10.618 2.2721 10.3637 2.16675 10.0985 2.16675C9.83325 2.16675 9.5789 2.2721 9.39136 2.45964C9.20383 2.64718 9.09847 2.90153 9.09847 3.16675V9.00008H3.26514C2.99992 9.00008 2.74557 9.10544 2.55803 9.29297C2.37049 9.48051 2.26514 9.73486 2.26514 10.0001C2.26514 10.2653 2.37049 10.5197 2.55803 10.7072C2.74557 10.8947 2.99992 11.0001 3.26514 11.0001H9.09847V16.8334C9.09847 17.0986 9.20383 17.353 9.39136 17.5405C9.5789 17.7281 9.83325 17.8334 10.0985 17.8334C10.3637 17.8334 10.618 17.7281 10.8056 17.5405C10.9931 17.353 11.0985 17.0986 11.0985 16.8334V11.0001H16.9318C17.197 11.0001 17.4514 10.8947 17.6389 10.7072C17.8264 10.5197 17.9318 10.2653 17.9318 10.0001C17.9318 9.73486 17.8264 9.48051 17.6389 9.29297C17.4514 9.10544 17.197 9.00008 16.9318 9.00008Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusWhite);
export default __webpack_public_path__ + "static/media/icon_plus_white.aa115b34b3367b96a605388b501c049d.svg";
export { ForwardRef as ReactComponent };